import { SphereContext, SphereController } from "../../base";
import { MeetingSummaryStates, getMeetingSummaryInitState } from "./meetingSummaryState";

export interface MeetingSummaryEvents {
  // Events will be added as needed
}

export class MeetingSummaryController extends SphereController<
  MeetingSummaryStates,
  MeetingSummaryEvents
> {
  key = "meetingSummary";

  constructor(context: SphereContext) {
    super(context, getMeetingSummaryInitState());
  }
}
